import { createElement } from 'react';
import { Monitor, Moon, Sun1 } from 'iconsax-reactjs';
import type { MenuItem } from '@/components/ui';
import { useOptionalTheme, type ThemePreference } from '@/components/theme';

const OPTIONS: { value: ThemePreference; label: string; icon: typeof Sun1 }[] = [
  { value: 'light', label: 'Light', icon: Sun1 },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
];

/**
 * Menu items for choosing the theme (a "Theme" heading plus light/dark/system radio items).
 * Returns [] when no ThemeProvider is mounted. Spread into UserMenu `items`.
 */
export function useThemeMenuItems(heading = 'Theme'): MenuItem[] {
  const theme = useOptionalTheme();
  if (!theme) return [];
  return [
    { type: 'heading', id: 'theme-heading', label: heading },
    ...OPTIONS.map<MenuItem>((option) => ({
      type: 'radio',
      id: `theme-${option.value}`,
      label: option.label,
      icon: createElement(option.icon, { size: 18, color: 'currentColor' }),
      checked: theme.preference === option.value,
      onSelect: () => theme.setPreference(option.value),
    })),
  ];
}
